import React from "react";

import clsx from "clsx";
import { TrailerTypeEnum } from "types/TrailerType";

export const containerTypes = [
  { value: TrailerTypeEnum.DRY, label: "Dry" },
  { value: TrailerTypeEnum.REEFER, label: "Reefer" },
  { value: TrailerTypeEnum.OPEN_TOP, label: "Open Top" },
  { value: TrailerTypeEnum.PLATFORM, label: "Platform" },
  { value: TrailerTypeEnum.FLAT_RACK, label: "Flat Rack" },
];

interface ContainerTypeTabPanelProps {
  selected?: string;
  onSelect: (type: string) => void;
  hasError?: boolean;
  className?: string;
}

export const ContainerTypeTabPanel: React.FC<ContainerTypeTabPanelProps> = ({
  selected,
  onSelect,
  hasError,
  className,
}) => {
  return (
    <div
      className={clsx(
        "flex space-x-1 p-1 rounded-lg w-full",
        className,
        hasError ? "bg-red-50 border border-red-300" : "bg-gray-100"
      )}
    >
      {containerTypes.map((type) => (
        <button
          key={type.value}
          type="button"
          onClick={() => onSelect(type.value)}
          className={clsx(
            "px-4 py-2 rounded-md text-sm font-medium transition-colors border flex-1",
            selected === type.value
              ? "border-blue-600 text-blue-600 bg-white shadow-sm"
              : "border-transparent text-gray-700 hover:text-gray-900 hover:bg-gray-200"
          )}
        >
          {type.label}
        </button>
      ))}
    </div>
  );
};
